import { render } from "./ReminderEdit.vue?vue&type=template&id=95b763e2"
import script from "./ReminderEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/reminder/ReminderEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95b763e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95b763e2', __exports__)) {
    api.reload('95b763e2', __exports__)
  }
  
  module.hot.accept("./ReminderEdit.vue?vue&type=template&id=95b763e2", () => {
    api.rerender('95b763e2', render)
  })

}


export default __exports__